import { connect } from 'react-redux';
import { getColors, getInputDataToSend } from '../../../../store/form/selectors';
import {
  setInputDataToSend,
} from '../../../../store/form/actions';
import ColorSection from './ColorSection';
import { getLoader } from '../../../../store/loader/selectors';

const mapStateToProps = (state) => ({
  loader: getLoader(state),
  colors: getColors(state),
  inputData: getInputDataToSend(state),
});

const mapDispatchToProps = (dispatch) => ({
  setInputDataToSend: (key, data) => {
    dispatch(setInputDataToSend(key, data));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ColorSection);
